import state from '../../store/main/state'

const getImage = (fileId, params = {}) => {
    return state.client
        .get(`/files/${fileId}/download`, {
            params: params,
                responseType: 'arraybuffer',
        });
}

export {
    getImage
}